import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Selections from "../../common/Selections";

/**
 * TABLE SYSTEMCOLORS
 */
function WagerLimitsBooks(props) {
  let idProfileLimits = props.WagerLimit.idProfileLimits;

  return (
    <Selections
      className="unlock-overflow"
      title="Profile Limit Books"
      // GET
      getUrl={"/Player/GetBooks"}
      // SELECTED
      getSelectedUrl={`/Profile/PlayerProfileLimitsBook_GetBooksList?idProfileLimits=${idProfileLimits}`}
      getSelectedProcess={(data = []) =>
        data.filter(({ checked }) => checked).map(({ idBook }) => idBook)
      }
      // INSERT
      insertUrl={"/Profile/PlayerProfileLimitsBook_Insert"}
      insertParams={(_, { idBook }) => ({
        IdBook: idBook,
        IdProfileLimits: idProfileLimits,
      })}
      // DELETE
      deleteUrl={"/Profile/PlayerProfileLimitsBook_Delete"}
      deleteParams={(_, { idBook }) => ({
        IdBook: idBook,
        IdProfileLimits: idProfileLimits,
      })}
    >
      <TableHeaderColumn visible="none" isKey={true} hidden dataField="idBook">
        IdBook
      </TableHeaderColumn>
      <TableHeaderColumn dataField="description">Description</TableHeaderColumn>
    </Selections>
  );
}

export default WagerLimitsBooks;
